<template>
  <template v-if="showingWrench">
    <div class="flex">
      <div class="left">
        <i class="pi pi-wrench" style="font-size: 11px;"></i>
      </div>
      <div class="center">
        <template v-if="tag.settingEnabled && tag.relevant">
          <slot></slot>
        </template>
        <template v-else-if="tag.settingEnabled && !tag.relevant">
          <span class="settingEnabledButNotRelevant">
            Setting enabled, not relevant
          </span>
        </template>
        <template v-else>
          <span class="settingDisabled">
            Setting disabled
          </span>
        </template>
      </div>
      <div class="right"></div>
    </div>
  </template>
  <template v-else>
    <slot v-if="tag.settingEnabled"></slot>
  </template>
</template>

<script setup>
import { computed } from "vue";
import store from "./store.js";

let props = defineProps([ "tag" ]);
let showingWrench = computed(() => store.showAdvanced && props.tag.settingOptional);

</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
.left, .right {
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
  text-align: right;
}
.center {
  flex-shrink: 1;
}
i {
  color: #444;
  font-size: small;
}
.settingDisabled,
.settingEnabledButNotRelevant {
  font-size: 14px;
  font-style: italic;
  white-space: wrap;
}
</style>